import {AsyncInlineError} from '@s-ui/decorators'
import {Repository} from '@s-ui/domain'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {ErrorsFactoriesFetcherValueObject} from '../../fetcher/ValueObjects/ErrorsFactoriesFetcherValueObject.js'
import {UserTraitsTrackingValueObject} from '../ValueObjects/UserTraitsTrackingValueObject.js'

/**
 * @class
 * @implements TrackingRepository
 */
export class HttpTrackingRepository extends Repository {
  #config
  #fetchOrFail

  constructor({config, fetchOrFail, savePageViewHitTrackingErrorFactory}) {
    super()
    this.#config = config
    this.#fetchOrFail = fetchOrFail

    this._savePageViewHitTrackingErrorFactory = savePageViewHitTrackingErrorFactory
  }

  static create({config}) {
    return new HttpTrackingRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config})
    })
  }

  @AsyncInlineError()
  savePageViewHit(pageViewHitVO) {
    const apiUrl = this.#config.get('API_URL')
    const {GENERIC} = this.#config.get('COMMON').ERRORS

    const {adId} = pageViewHitVO.toJSON()

    if (!adId) return Promise.reject(this._savePageViewHitTrackingErrorFactory('Page View hit not valid'))

    return this.#fetchOrFail
      .withErrorsFactories({
        [GENERIC]: () => this._savePageViewHitTrackingErrorFactory('Page View hit could not be saved')
      })
      .post(`${apiUrl}/hits/vehicles/${adId}/page-view`)
      .then(([error]) => {
        if (error) return Promise.reject(error)
        return Promise.resolve()
      })
  }

  @AsyncInlineError()
  async getUserTraits() {
    const apiUrl = this.#config.get('API_URL')
    const {ERROR_RESPONSES} = this.#config.get('COMMON')

    const errorsFactoriesValueObject = ErrorsFactoriesFetcherValueObject.createFromErrorsConfig({
      errorsConfig: ERROR_RESPONSES.TRACKING.GET_USER_TRAITS
    })

    const [error, response] = await this.#fetchOrFail
      .withErrorsFactories(errorsFactoriesValueObject.getFactories())

      .get(`${apiUrl}/segment/users/traits`)

    if (error) return Promise.reject(error)

    return UserTraitsTrackingValueObject.createFromApi({traits: response.data.traits})
  }
}
